export default {
  default: {
    currency: ['$', ''],
    decimal: '.',
    grouping: [3],
    thousands: ',',
  },
}